import { Reducer } from 'redux'

import * as ActionTypes from './constants'
import { MovedCitationsState } from './types'

export const initialState = {
  count: null,
  projectName: null,
  projectId: null,
}

export const movedCitationsReducer: Reducer<MovedCitationsState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ActionTypes.MOVED_CITATIONS_SUCCEEDED:
      return action.payload
    case ActionTypes.MOVED_CITATIONS_CLEARED:
      return initialState
    default:
      return state
  }
}

export default movedCitationsReducer
